import { SaveResultMessage } from "@/components/test/SaveResultMessage";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";


export const BeckResults = ({ scores }) => {
    const results = scores.map(obj => new Map(Object.entries(obj)))
        .filter(Boolean)
        .flatMap((map) => Array.from(map.values()))
        .reduce((sum, val) => sum + val, 0);;

    const getDiagnosis = (score) => {
        if (score <= 9) {
            return "По результатам теста у вас отсутствиют депрессивные симптомы";
        } else if (score <= 15) {
            return "По результатам теста у вас есть легкая депрессия (субдепрессия)";
        } else if (score <= 19) {
            return "По результатам теста у вас есть умеренная депрессия";
        } else if (score <= 29) {
            return "По результатам теста у вас есть выраженная депрессия (средней тяжести)";
        } else {
            return "По результатам теста у вас есть тяжелая депрессия";
        }
    };
    console.log(results)

    return (
        <div>
            <SaveResultMessage />

            <div className="text-center p-4 border rounded-lg">
                <h3 className="text-center mb-0 mt-8">
                    Вы набрали {results} балла
                </h3>
                <br />
                <strong>{getDiagnosis(results)}.</strong>
                <br />
                <br />
                <p>
                    Внимание! Тест не является абсолютным и может быть применен в
                    разных ситуациях. Для постановки определенного уровня депрессии
                    следует обратиться к соответствующему специалисту.
                </p>
            </div>
            <div className="my-4 mt-8">
                <b className="py-4">Таблица градации результатов:</b>
            </div>
            <Table>
                <TableHeader>
                    <TableRow>
                        <TableHead>
                            <b>Баллы</b>
                        </TableHead>
                        <TableHead>
                            <b>Ожидаемый диагноз</b>
                        </TableHead>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    <TableRow>
                        <TableCell className="text-left">от 0 до 9</TableCell>
                        <TableCell className="text-left">
                            отсутствие депрессивных симптомов
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell className="text-left">от 10 до 15</TableCell>
                        <TableCell className="text-left">
                            легкая депрессия (субдепрессия)
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell className="text-left">от 16 до 19</TableCell>
                        <TableCell className="text-left">умеренная депрессия</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell className="text-left">от 20 до 29</TableCell>
                        <TableCell className="text-left">
                            выраженная депрессия (средней тяжести)
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell className="text-left">от 30 до 63</TableCell>
                        <TableCell className="text-left">тяжелая депрессия</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </div>
    )
}